export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6983.fa0f778d.jpg";